import OliverText from "@builder/components/general/OliverText";
import SingleSelect from "@builder/components/general/SelectInputNew/SingleSelect";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useGetZapierCustomTriggersQuery } from "@builder/store/slices/zapier/zapierApiSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ZapierTrigger } from "@builder/types/Zapier.type";
import { ActionType } from "@common/build/types";
import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const Zapier = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    // const company = useAppSelector(state => state.storeData.data?.company);
    const companyId = useAppSelector(state => state.builder.build.companyId);

    const { data: zapierCustomTriggers } = useGetZapierCustomTriggersQuery(companyId ? companyId : skipToken);

    const selectedTrigger = useMemo(() => {
        if (zapierCustomTriggers) {
            const trigger = zapierCustomTriggers?.find(trigger => trigger.triggerUrl === actionStep?.action?.data?.triggerUrl);
            if (trigger) {
                return trigger;
            }
        }
        return null;
    }, [actionStep, zapierCustomTriggers]);

    const handleZapierTrigger = (customTrigger: ZapierTrigger | null) => {
        console.log(customTrigger);
        if (customTrigger?.triggerUrl) {
            const action = {
                type: ActionType.ZAPIER,
                data: {
                    triggerUrl: customTrigger.triggerUrl
                }
            };
            const updatedStep = { ...actionStep, action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id, item: updatedStep as ActionEditorItem }));
            }
        }
    };

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <OliverText text="Select desitination zap" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                <SingleSelect
                    options={zapierCustomTriggers || []}
                    value={selectedTrigger}
                    onChange={handleZapierTrigger}
                    getOptionLabel={option => option.customTriggerName}
                    placeholder={t("popup.actionBuilder.zapier_placeholder")}
                />
            </div>
        </div>
    );
};

export default Zapier;
